module.exports = __webpack_public_path__ + "static/media/crop.b313cb03.svg";